import { getConfig } from '../utilities';

const useMenuView = async() => {

  let configParams = await getConfig(localStorage.getItem('path'))
  //console.log(configParams)
  return configParams;
}

export default useMenuView;